import { makeAutoObservable } from "mobx";

import { PostalRateModelDTO } from "./PostalRateModelDTO";
import { StockistBasketItemDTO } from "./StockistBasketItemDTO";

export class StockistBasketDTO {
	//#region defaultProperties
	readonly stockistId: number
	readonly addressId: number
	readonly currency: number
	readonly created: Date
	readonly items: StockistBasketItemDTO[]
	readonly deliveryFrom: PostalRateModelDTO;
	readonly purchasableItems: StockistBasketItemDTO[]
	// calculated
	readonly totalIssuePrice: number
	readonly totalDiscountedIssuePrice: number
	readonly totalDiscountPercentage: number
	readonly totalDiscountAmount: number
	readonly displayPrice: number
	// #endregion

	constructor(data: StockistBasketDTO) {
		this.stockistId = data.stockistId
		this.addressId = data.addressId
		this.currency = data.currency
		this.created = new Date(data.created)
		this.items = (data.items ?? []).map(item => new StockistBasketItemDTO(item))
		this.deliveryFrom = data.deliveryFrom
		this.purchasableItems = (data.purchasableItems ?? []).map(item => new StockistBasketItemDTO(item))
		this.totalIssuePrice = data.totalIssuePrice
		this.totalDiscountedIssuePrice = data.totalDiscountedIssuePrice
		this.totalDiscountPercentage = data.totalDiscountPercentage
		this.totalDiscountAmount = data.totalDiscountAmount
		this.displayPrice = data.displayPrice

		makeAutoObservable(this)
	}
}